<template>
    <div class="">
        <h1>Coming Soon</h1>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>